import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import moment from 'moment';
import axios from 'axios';
import { MySwal, AlertSwal, IconSwal } from '../CustomSwal';
import { useIntl, FormattedMessage } from 'react-intl';
import {
  AppointmentDateS0,
  AppointmentTimeS0,
  AppointmentDateS1,
  AppointmentTimeS1,
  AppointmentDateS2,
  AppointmentTimeS2,
  AppointmentNightS0,
  AppointmentNightS1,
  AppointmentNightS2,
  AppointmentMultiple
} from './AppointmentModalBody';

function AppointmentModal(props) {
  // s0 state
  const [stage, setStage] = useState(0);
  const [sdate, setSdate] = useState(moment());
  const [edate, setEdate] = useState(moment().add((parseInt(props.params.oncecanbooktime) - 1), 'days'));
  const [stime, setStime] = useState("00:00");
  const [etime, setEtime] = useState("00:00");
  // s1 state
  const [s1data, setS1data] = useState(null);
  const [s1checked, setS1checked] = useState('');
  // s2 state
  const [s2data, setS2data] = useState(null);

  // multiple state
  const [userids, setUserids] = useState([]);
  const [stateUserIds, setStateUserIds] = useState(null);

  const intl = useIntl();
  const config = props.config;
  const formType = props.selectedzone ? config.SPACETYPE[`st_${props.selectedzone.spacetype}`][0] : null;
  // const formUserNumber = props.selectedzone ? config.SPACETYPE[`st_${props.selectedzone.spacetype}`][1] : null;
  const formUserNumber = props.params.bookuser;
  const userid = sessionStorage.getItem('userid');
  const sid = sessionStorage.getItem('sid');
  const authid = sessionStorage.getItem('authid');

  const BookDeviceQuery = (qtype) => {
    let valid = true;
    let invalidMsg = '';
    let params = {};
    if (qtype === 'date') {
      const seqdays = document.getElementById('seqdays').value;
      params = {
        sid: sid,
        authid: authid,
        spacetype: props.selectedzone.spacetype,
        zoneid: props.selectedzone.zoneid,
        sdate: sdate.format('YYYY/MM/DD'),
        edate: edate.format('YYYY/MM/DD'),
        seqdays: seqdays,
        restype: 'json'
      }
    } else if (qtype === 'time') {
      const now = moment();
      const beginningTime = moment(stime, 'HH:mm');
      const endTime = moment(etime, 'HH:mm');
      if (endTime.isBefore(beginningTime)) {
        valid = false;
        invalidMsg = intl.formatMessage({ id: 'appointment.alert.end_time_must_larger' });
      }
      if (sdate.isSame(now, 'day')) {
        if (beginningTime.isBefore(now) && now.diff(beginningTime, 'minutes') > 31) {
          valid = false;
          invalidMsg = intl.formatMessage({ id: 'appointment.alert.not_expired' });
        }
      }
      params = {
        sid: sid,
        authid: authid,
        spacetype: props.selectedzone.spacetype,
        zoneid: props.selectedzone.zoneid,
        sdate: sdate.format('YYYY/MM/DD'),
        shh: stime.split(':')[0],
        smm: stime.split(':')[1],
        ehh: etime.split(':')[0],
        emm: etime.split(':')[1],
        restype: 'json'
      }
    } else if (qtype === 'night') {
      const now = moment();
      const beginningTime = moment(stime, 'HH:mm');
      if (sdate.isSame(now, 'day')) {
        if (beginningTime.isBefore(now) && now.diff(beginningTime, 'minutes') > 31) {
          valid = false;
          invalidMsg = intl.formatMessage({ id: 'appointment.alert.not_expired' });
        }
      }
      params = {
        sid: sid,
        authid: authid,
        spacetype: props.selectedzone.spacetype,
        zoneid: props.selectedzone.zoneid,
        sdate: sdate.format('YYYY/MM/DD'),
        shh: stime.split(':')[0],
        smm: stime.split(':')[1],
        ehh: etime.split(':')[0],
        emm: etime.split(':')[1],
        restype: 'json'
      }
    }
    if (valid) {
      props.setLoading(true);
      axios.get(config.API_URL + `/BookDeviceQuery.aspx`, {
        params: params
      }).then((res) => {
        const data = res.data[0];
        if (data.rescode === '3' || data.rescode === '4') {
          props.setSession(false);
        } else {
          if (data.rescode === '1') {
            if (data.resdata) {
              setS1checked('');
              setS1data(data.resdata);
              setStage(stage + 1);
            } else {
              AlertSwal.fire({
                title: intl.formatMessage({ id: 'global.alert_title' }),
                text: intl.formatMessage({ id: 'appointment.alert.query_no_data' }),
                confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
              })
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: 'global.alert_title' }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
            })
          }
        }
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        props.setLoading(false);
      })
    } else {
      AlertSwal.fire({
        title: intl.formatMessage({ id: 'global.alert_title' }),
        text: invalidMsg,
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
      })
    }
  }

  const BookTimeSegQuery = (qtype) => {
    if (document.querySelector('input[name="deviceid"]:checked')) {
      let params = {};
      const deviceid = document.querySelector('input[name="deviceid"]:checked').value;
      setS1checked(deviceid);
      if (qtype === 'date') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          sdate: sdate.format('YYYY/MM/DD'),
          edate: edate.format('YYYY/MM/DD'),
          deviceid: deviceid,
          restype: 'json'
        }
      } else if (qtype === 'time') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          sdate: sdate.format('YYYY/MM/DD'),
          deviceid: deviceid,
          restype: 'json'
        }
      } else if (qtype === 'night') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          sdate: sdate.format('YYYY/MM/DD'),
          deviceid: deviceid,
          restype: 'json'
        }
      }
      props.setLoading(true);
      axios.get(config.API_URL + `/BookTimeSegQuery.aspx`, {
        params: params
      }).then((res) => {
        const data = res.data[0];
        if (data.rescode === '3' || data.rescode === '4') {
          props.setSession(false);
        } else {
          if (data.rescode === '1') {
            setS2data(data.resdata);
            setStage(stage + 1);
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: 'global.alert_title' }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
            })
          }
        }
      }).catch((error) => {
        console.error(error)
      }).finally(() => {
        props.setLoading(false);
      })
    } else {
      AlertSwal.fire({
        title: intl.formatMessage({ id: 'global.alert_title' }),
        text: intl.formatMessage({ id: 'appointment.alert.select_space' }),
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
      })
    }
  }

  const BookAdd = (qtype) => {
    // 檢查是否有選擇日期時間
    let bookvalues = document.querySelector('input[name="bookvalue"]:checked');
    if (bookvalues) {
      let swalMsg;
      let viewArr = [];
      let viewDates = [];
      let params = {};
      let bookvalue = '';
      let useridparam = '';
      if (parseInt(formUserNumber) === 1) {
        useridparam = userid;
      } else if (parseInt(formUserNumber) > 1) {
        useridparam = userid + ',' + stateUserIds;
      }
      const checkboxes = document.getElementsByName('bookvalue');
      // 整理要送出的日期時間格式
      for (let i = 0, n = checkboxes.length; i < n; i++) {
        if (checkboxes[i].checked) {
          bookvalue += "," + checkboxes[i].value;
          viewArr.push(checkboxes[i].getAttribute('viewvalue'));
          viewDates.push(checkboxes[i].getAttribute('viewdate'));
        }
      }
      if (bookvalue) bookvalue = bookvalue.substring(1);
      // date time 參數 + swal 的內容 判別
      if (qtype === 'date') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: s1checked,
          userid: useridparam,
          sdate: sdate.format('YYYY/MM/DD'),
          bookdate: bookvalue,
          restype: 'json'
        }
        swalMsg =
          <div className="text-left">
            <span>{intl.formatMessage({ id: 'global.reader_id' })} : </span><span className="d-inline-block">{useridparam}</span><br />
            <span>{intl.formatMessage({ id: 'global.zonename' })} : </span><span className="d-inline-block">{intl.formatMessage({ id: `global.zoneid.${props.selectedzone.zoneid}`, defaultMessage: props.selectedzone.zonename })}</span><br />
            <span>{intl.formatMessage({ id: 'global.devicename' })} : </span><span className="d-inline-block">{s2data[0].devicename}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_date' })} : </span><span className="d-inline-block">{(viewArr.length === 1 ? viewArr[0] : `${viewArr[0]} ~ ${viewArr[viewArr.length - 1]}`)}</span>
          </div>
          ;
      } else if (qtype === 'time') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: s1checked,
          userid: useridparam,
          sdate: sdate.format('YYYY/MM/DD'),
          booktime: bookvalue,
          restype: 'json'
        }
        swalMsg =
          <div className="text-left">
            <span>{intl.formatMessage({ id: 'global.reader_id' })} : </span><span className="d-inline-block">{useridparam}</span><br />
            <span>{intl.formatMessage({ id: 'global.zonename' })} : </span><span className="d-inline-block">{intl.formatMessage({ id: `global.zoneid.${props.selectedzone.zoneid}`, defaultMessage: props.selectedzone.zonename })}</span><br />
            <span>{intl.formatMessage({ id: 'global.devicename' })} : </span><span className="d-inline-block">{s2data[0].devicename}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_date' })} : </span><span className="d-inline-block">{sdate.format('YYYY/MM/DD')}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_time' })} : </span><span className="d-inline-block">{(viewArr.length === 1 ? viewArr[0].replace('~', ' ~ ') : `${viewArr[0].split('~')[0]} ~ ${viewArr[viewArr.length - 1].split('~')[1]}`)}</span>
          </div>
          ;
      } else if (qtype === 'night') {
        params = {
          sid: sid,
          authid: authid,
          spacetype: props.selectedzone.spacetype,
          deviceid: s1checked,
          userid: useridparam,
          sdate: sdate.format('YYYY/MM/DD'),
          booktime: bookvalue,
          restype: 'json'
        }
        let datetimeText = '';
        if (viewArr.length === 1) {
          if (viewArr[0].split(' ').length > 1) {
            datetimeText = viewDates[0] + ' ' + viewArr[0].split(' ')[1].replace('~', ' ~ ');
          } else {
            datetimeText = viewDates[0] + ' ' + viewArr[0].replace('~', ' ~ ');
          }
        } else {
          let stext = '';
          let etext = '';
          if (viewArr[0].split(' ').length > 1) {
            stext = viewArr[0].split(' ')[1].split('~')[0];
          } else {
            stext = viewArr[0].split('~')[0];
          }
          if (viewArr[viewArr.length - 1].split(' ').length > 1) {
            etext = viewArr[viewArr.length - 1].split(' ')[1].split('~')[1];
          } else {
            etext = viewArr[viewArr.length - 1].split('~')[1];
          }
          if (viewDates[0] !== viewDates[viewArr.length - 1]) {
            datetimeText = viewDates[0] + ' ' + stext + ' ~ ' + viewDates[viewArr.length - 1] + ' ' + etext;
          } else {
            datetimeText = viewDates[0] + ' ' + stext + ' ~ ' + etext;
          }
        }
        swalMsg =
          <div className="text-left">
            <span>{intl.formatMessage({ id: 'global.reader_id' })} : </span><span className="d-inline-block">{useridparam}</span><br />
            <span>{intl.formatMessage({ id: 'global.zonename' })} : </span><span className="d-inline-block">{intl.formatMessage({ id: `global.zoneid.${props.selectedzone.zoneid}`, defaultMessage: props.selectedzone.zonename })}</span><br />
            <span>{intl.formatMessage({ id: 'global.devicename' })} : </span><span className="d-inline-block">{s2data[0].devicename}</span><br />
            <span>{intl.formatMessage({ id: 'global.reservation_time' })} : </span><span className="d-inline-block">{datetimeText}</span>
          </div>
          ;
      }
      MySwal.fire({
        title: intl.formatMessage({ id: 'appointment.reservation_detail' }),
        html: swalMsg,
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
        cancelButtonText: intl.formatMessage({ id: 'global.cancel' })
      }).then((result) => {
        if (result.value) {
          props.setLoading(true);
          axios.get(config.API_URL + `/BookAdd.aspx`, {
            params: params
          }).then((res) => {
            const data = res.data[0];
            if (data.rescode === '3' || data.rescode === '4') {
              props.setSession(false);
            } else {
              if (data.rescode === '1') {
                props.setshow(false);
                if (config.SHOW_GOOGLE) {
                  IconSwal.fire({
                    title: intl.formatMessage({ id: 'appointment.success_reservation' }),
                    icon: 'success',
                    html: <span>{intl.formatMessage({ id: 'appointment.add_to_google' })}？</span>,
                    showCancelButton: true,
                    confirmButtonText: intl.formatMessage({ id: 'global.yes' }),
                    cancelButtonText: intl.formatMessage({ id: 'global.no' })
                  }).then((result) => {
                    if (result.value) {
                      const googleForm = document.getElementById('googleForm');
                      googleForm.querySelector('input[name=spacetype]').value = props.selectedzone.spacetype;
                      googleForm.querySelector('input[name=deviceid]').value = s1checked;
                      googleForm.querySelector('input[name=readerid]').value = userid;
                      googleForm.querySelector('input[name=booksdate]').value = (qtype === 'date') ? viewArr[0] : sdate.format('YYYY/MM/DD');
                      googleForm.querySelector('input[name=bookedate]').value = (qtype === 'date') ? viewArr[viewArr.length - 1] : sdate.format('YYYY/MM/DD');
                      googleForm.querySelector('input[name=binbooktime]').value = (qtype === 'date') ? '' : bookvalue;
                      googleForm.submit();
                    }
                    props.setCurrent('info');
                    props.history.push('/redirect_to/info');
                  });
                } else {
                  IconSwal.fire({
                    title: intl.formatMessage({ id: 'appointment.success_reservation' }),
                    icon: 'success',
                    showCancelButton: false,
                    customClass: {
                      header: 'bg_swal swal-icon-header justify-content-around',
                      title: 'modal-title',
                      icon: 'swal-icon-class',
                      actions: 'modal-footer d-flex justify-content-center',
                      confirmButton: 'bg_brand btn btn-primary'
                    }
                  }).then((result) => {
                    props.setCurrent('info');
                    props.history.push('/redirect_to/info');
                  });
                }
              } else {
                let errMsg = data.resmsg.match(/\[(.*?)\]/);
                AlertSwal.fire({
                  title: intl.formatMessage({ id: 'global.alert_title' }),
                  text: errMsg ? intl.formatMessage({ id: `serverResponse.${errMsg[1]}` }) : intl.formatMessage({ id: 'serverResponse.default' }),
                  confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
                })
              }
            }
          }).catch((error) => {
            console.error(error)
          }).finally(() => {
            props.setLoading(false);
          })
        }
      })
    } else {
      AlertSwal.fire({
        title: intl.formatMessage({ id: 'global.alert_title' }),
        text: intl.formatMessage({ id: 'appointment.alert.select_period' }),
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
      })
    }
  }

  const BookUserVerify = (qtype) => {
    let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index);
    let valid = true;
    let invalidMsg = '';
    let params = {};
    let useridparam = '';
    if (findDuplicates(userids).length > 0) {
      valid = false;
      invalidMsg = intl.formatMessage({ id: 'appointment.alert.reader_id_repeat' });
    }
    for (let i = 0; i < parseInt(formUserNumber) - 1; i++) {
      if (userids[i] !== '' && userids[i] !== undefined) {
        if (userids[i].toUpperCase() === userid.toUpperCase()) {
          valid = false;
          invalidMsg = intl.formatMessage({ id: 'appointment.alert.reader_id_self' });
        } else if (userids[i].match(/^[a-zA-Z0-9]+$/)) {
          useridparam += "," + userids[i];
        } else {
          valid = false;
          invalidMsg = intl.formatMessage({ id: 'appointment.alert.reader_id_invalid' });
        }
      } else {
        valid = false;
        invalidMsg = intl.formatMessage({ id: 'appointment.alert.reader_id_empty' });
      }
    }
    if (useridparam) useridparam = useridparam.substring(1);
    params = {
      sid: sid,
      authid: authid,
      spacetype: props.selectedzone.spacetype,
      userid: useridparam,
      restype: 'json'
    }
    if (valid) {
      props.setLoading(true);
      axios.get(config.API_URL + `/BookUserVerify.aspx`, {
        params: params
      }).then((res) => {
        const data = res.data[0];
        if (data.rescode === '3' || data.rescode === '4') {
          props.setSession(false);
        } else {
          if (data.rescode === '1') {
            setStateUserIds(useridparam);
            setStage(stage + 1);
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: 'global.alert_title' }),
              text: intl.formatMessage({ id: 'serverResponse.code_011' }),
              confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
            })
          }
        }
      }).catch((error) => {
        console.error(error);
      }).finally(() => {
        props.setLoading(false);
      })
    } else {
      AlertSwal.fire({
        title: intl.formatMessage({ id: 'global.alert_title' }),
        text: invalidMsg,
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
      })
    }
  }

  const SchAllModal = (qtype) => {
    const params = {
      enableToBook: true,
      spacetype: props.selectedzone.spacetype,
      sdate: sdate.format('YYYY/MM/DD'),
      edate: formType === 'date' ? edate.format('YYYY/MM/DD') : null,
      zonename: props.selectedzone.zonename,
      userids: stateUserIds
    }
    props.setAllData(params);
    props.setAllShow(true);
  }

  return (
    <Modal size='xl'
      show={props.show}
      onShow={() => {
        props.setShowScrollArrow(true);
      }}
      onHide={() => {
        props.setshow(false);
        props.setSelectedZone(null);
        props.setShowScrollArrow(false);
      }}
      centered
    >
      <Modal.Header className="bg_brand" closeButton>
        <Modal.Title>{props.selectedzone ? <FormattedMessage defaultMessage={props.selectedzone.zonename} id={`global.zoneid.${props.selectedzone.zoneid}`} /> : null} {s2data ? `【${s2data[0].devicename}】` : null}</Modal.Title>
      </Modal.Header>
      <ModalBody
        {...props}
        formType={formType}
        formUserNumber={parseInt(formUserNumber)}
        stage={stage}
        // s0 props
        sdate={sdate}
        edate={edate}
        stime={stime}
        etime={etime}
        setSdate={setSdate}
        setEdate={setEdate}
        setStime={setStime}
        setEtime={setEtime}
        params={props.selectedzone.params}
        setSession={props.setSession}
        // s1 props
        s1data={s1data}
        s1checked={s1checked}
        // s2 props
        s2data={s2data}
        // multiple props
        userids={userids}
        setUserids={setUserids}
        stateUserIds={stateUserIds}
      />
      <ModalFooter
        formType={formType}
        params={props.params}
        formUserNumber={parseInt(formUserNumber)}
        stage={stage}
        setStage={setStage}
        setS2data={setS2data}
        setshow={props.setshow}
        BookDeviceQuery={BookDeviceQuery}
        BookTimeSegQuery={BookTimeSegQuery}
        BookAdd={BookAdd}
        BookUserVerify={BookUserVerify}
        SchAllModal={SchAllModal}
      />
    </Modal>
  )
}

function ModalBody(props) {
  let modalForm = [];
  if (props.formType === 'date') {
    modalForm[0] =
      <AppointmentDateS0
        formType={props.formType}
        sdate={props.sdate}
        setSdate={props.setSdate}
        edate={props.edate}
        setEdate={props.setEdate}
        setSession={props.setSession}
        params={props.params}
      />;
    modalForm[1] =
      <AppointmentDateS1
        {...props}
        formType={props.formType}
        data={props.s1data}
        checked={props.s1checked}
      />;
    modalForm[2] =
      <AppointmentDateS2
        formType={props.formType}
        params={props.params}
        data={props.s2data}
      />;
  } else if (props.formType === 'time') {
    modalForm[0] =
      <AppointmentTimeS0
        {...props}
      />;
    modalForm[1] =
      <AppointmentTimeS1
        {...props}
        formType={props.formType}
        data={props.s1data}
        checked={props.s1checked}
      />;
    modalForm[2] =
      <AppointmentTimeS2
        formType={props.formType}
        params={props.params}
        data={props.s2data}
      />;
  } else if (props.formType === 'night') {
    modalForm[0] =
      <AppointmentNightS0
        {...props}
      />;
    modalForm[1] =
      <AppointmentNightS1
        {...props}
        formType={props.formType}
        data={props.s1data}
        checked={props.s1checked}
      />;
    modalForm[2] =
      <AppointmentNightS2
        formType={props.formType}
        params={props.params}
        data={props.s2data}
      />;
  }

  if (props.formUserNumber > 1) {
    let multipleForm =
      <AppointmentMultiple formType={props.formType} formUserNumber={props.formUserNumber} userids={props.userids} setUserids={props.setUserids} />;
    modalForm.unshift(multipleForm);
  }

  return (
    <Modal.Body>
      {modalForm[props.stage]}
    </Modal.Body>
  )
}

function ModalFooter(props) {
  let modalFooter = [];
  modalFooter[0] =
    <div style={{ marginLeft: 'auto' }} className="d-flex justify-items-center">
      <Button variant="secondary"
        onClick={() => props.SchAllModal(props.formType)}>
        {props.formType === 'date' ?
          <FormattedMessage id='appointment.search_by_date_range' /> :
          <FormattedMessage id='appointment.search_by_date' />}
      </Button>
      <Button className="bg_brand" variant="primary"
        onClick={() => props.BookDeviceQuery(props.formType)}>
        {props.formType === 'date' ?
          props.params.oncecanbooktime === '1' ?
            <FormattedMessage id='appointment.search_by_continuous_use_single' /> :
            <FormattedMessage id='appointment.search_by_continuous_use' /> :
          <FormattedMessage id='appointment.search_by_period' />}
      </Button>
    </div>;
  modalFooter[1] =
    <>
      <Button variant="light"
        onClick={() => props.setStage(props.stage - 1)}>
        <FormattedMessage id='global.back' />
      </Button>
      <Button className="bg_brand" variant="primary"
        onClick={() => props.BookTimeSegQuery(props.formType)}>
        <FormattedMessage id='global.next' />
      </Button>
    </>;
  modalFooter[2] =
    <>
      <Button variant="light" onClick={() => {
        props.setS2data(null);
        props.setStage(props.stage - 1);
      }}><FormattedMessage id='global.back' /></Button>
      <Button className="bg_brand" variant="primary"
        onClick={() => props.BookAdd(props.formType)}>
        <FormattedMessage id='appointment.confirm_reservation_detail' />
      </Button>
    </>;

  if (props.formUserNumber > 1) {
    modalFooter[0] =
      <>
        <Button variant="light" onClick={() => props.setStage(props.stage - 1)}>
          <FormattedMessage id='global.back' />
        </Button>
        <div style={{ marginLeft: 'auto' }} className="d-flex justify-items-center">
          <Button variant="secondary"
            onClick={() => props.SchAllModal(props.formType)}>
            {props.formType === 'date' ?
              <FormattedMessage id='appointment.search_by_date_range' /> :
              <FormattedMessage id='appointment.search_by_date' />}
          </Button>
          <Button className="bg_brand" variant="primary"
            onClick={() => props.BookDeviceQuery(props.formType)}>
            {props.formType === 'date' ?
              props.params.oncecanbooktime === '1' ?
                <FormattedMessage id='appointment.search_by_continuous_use_single' /> :
                <FormattedMessage id='appointment.search_by_continuous_use' /> :
              <FormattedMessage id='appointment.search_by_period' />}
          </Button>
        </div>
      </>;

    let multipleFooter =
      <>
        <Button style={{ marginLeft: 'auto' }} className="bg_brand" variant="primary"
          onClick={() => props.BookUserVerify(props.formType)}>
          <FormattedMessage id='appointment.reader_query' />
        </Button>
      </>;
    modalFooter.unshift(multipleFooter);
  }

  return (
    <Modal.Footer className='d-flex justify-content-between'>
      {modalFooter[props.stage]}
    </Modal.Footer>
  )
}

// function usePrevious(value) {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// }

export default AppointmentModal;